/** A failed lookup is never permission to render a cached private session. */
export function sessionLookupRejected(error: unknown): boolean {
  const status = (error as { response?: { status?: number } } | null)?.response?.status
  return status === 401 || status === 403
}
